import { useEffect, useState } from "react";
import { studio, setCurrency } from "@/lib/studioApi";

let cache = null;
let pending = null;

/* Règles fiscales de l'organisation (pays, devise, taux, identifiants) — chargées une fois par session. */
export const loadFiscal = () => {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = studio.get("/fiscal/rules").then(({ data }) => { cache = data; setCurrency(data.currency); return data; }).finally(() => { pending = null; });
  }
  return pending;
};
export const resetFiscal = () => { cache = null; };

export const useFiscal = () => {
  const [fiscal, setFiscal] = useState(cache);
  useEffect(() => { loadFiscal().then(setFiscal).catch(() => setFiscal({ country: "BE", currency: "EUR", rates: [21, 12, 6, 0], standard_rate: 21, countries: [], tax_ids: [], rate_details: [] })); }, []);
  return fiscal;
};

export const decideFiscal = (payload) => studio.post("/fiscal/decide", payload).then(({ data }) => data);

export const CLIENT_TYPES = [["particulier", "Particulier"], ["professionnel", "Professionnel (assujetti)"]];
export const TREATMENT_LABELS = {
  standard: "TVA de votre pays", reverse_charge: "Autoliquidation", intracom: "Intracommunautaire (autoliquidation)",
  export: "Export / hors champ", foreign_property: "TVA du pays du bien", needs_info: "Informations manquantes",
};
